import DigiobcanApi from '../../api/DigiobcanApi';
import { createQueryFn, QueryNameSpace } from '../../lib/query';
import type { QueryFunctionContext } from '@tanstack/react-query';

type Params = {
  view?: 'flat' | 'tree';
};

export const getNewsCategories = createQueryFn(
  QueryNameSpace.getNewsCategories,
  async ({ queryKey }: QueryFunctionContext<[string] | [string, Params]>) => {
    const [, params] = queryKey;

    const { news_categories } = await DigiobcanApi.getNewsCategories(params);

    return news_categories;
  },
);
